// src/data/articleLinks.js

export const articleLinks = {
  'discovery_history_of_america_part_01': {
	topic_id: 1,
	topic_code: 'discovery',
	article_serial_id: 1,
    to: '/discovery/USAHistorical/en/history-america-part-1',
    title: 'History of America - Part 1 - US The Seeds of a Superpower: America’s Colonial Foundations and Fight for Independence (1607–1789)',
  },
  'discovery_history_of_america_part_02': {
	topic_id: 1,
	topic_code: 'discovery',
	article_serial_id: 2,
    to: '/discovery/USAHistorical/en/history-america-part-2',
    title: 'History of America - Part 2: Expansion and Industrial Growth (1790–1860)',
  },
  'discovery_history_of_america_part_03': {
	topic_id: 1,
	topic_code: 'discovery',
	article_serial_id: 3,
    to: '/discovery/USAHistorical/en/history-america-part-3',
    title: 'History of America - Part 3: Civil War and Reconstruction (1861–1877)',
  },
  'discovery_history_of_america_part_04': {
	topic_id: 1,
	topic_code: 'discovery',
	article_serial_id: 4,
    to: '/discovery/USAHistorical/en/history-america-part-4',
    title: 'History of America - Part 4: The Gilded Age and Progressive Era (1877–1920)',
  },
  'discovery_history_of_america_part_05': {
	topic_id: 1,
	topic_code: 'discovery',
	article_serial_id: 5,
    to: '/discovery/USAHistorical/en/history-america-part-5',
    title: 'History of America - Part 5: The Roaring Twenties and the Great Depression (1920–1939)',
  },
  'discovery_history_of_america_part_06': {
	topic_id: 1,
	topic_code: 'discovery',
	article_serial_id: 6,
    to: '/discovery/USAHistorical/en/history-america-part-6',
    title: 'History of America - Part 6: World War II and Its Aftermath (1939–1950)',
  },
  'discovery_history_of_america_part_07': {
	topic_id: 1,
	topic_code: 'discovery',
	article_serial_id: 7,
    to: '/discovery/USAHistorical/en/history-america-part-7',
    title: 'History of America - Part 7: The Cold War and Civil Rights Era (1950–1970)',
  },
  'discovery_history_of_america_part_08': {
	topic_id: 1,
	topic_code: 'discovery',
	article_serial_id: 8,
    to: '/discovery/USAHistorical/en/history-america-part-8',
    title: 'History of America - Part 8: Vietnam, Watergate, and Economic Challenges (1970–1980)',
  },
  'discovery_history_of_america_part_09': {
	topic_id: 1,
	topic_code: 'discovery',
	article_serial_id: 9,
    to: '/discovery/USAHistorical/en/history-america-part-9',
    title: 'History of America - Part 9: The Reagan Era and the End of the Cold War (1980–1991)',
  },
  'discovery_history_of_america_part_10': {
	topic_id: 1,
	topic_code: 'discovery',
	article_serial_id: 10,
    to: '/discovery/USAHistorical/en/history-america-part-10',
    title: 'History of America - Part 10: The Post–Cold War Era and Globalization (1991–2001)',
  },
  'discovery_history_of_america_part_11': {
	topic_id: 1,
	topic_code: 'discovery',
	article_serial_id: 11,
    to: '/discovery/USAHistorical/en/history-america-part-11',
    title: 'History of America - Part 11: The War on Terror and the Digital Revolution (2001–2010)',
  },
  'discovery_history_of_america_part_12': {
	topic_id: 1,
	topic_code: 'discovery',
	article_serial_id: 12,
    to: '/discovery/USAHistorical/en/history-america-part-12',
    title: 'History of America - Part 12: Social Change, Polarization, and Innovation (2010–2020)',
  },

  /* JOKING*/
  
  'joking_part_01': {
	topic_id: 2,
	article_serial_id: 13,
	topic_code: 'joking',
    to: '/joking/en/joking_part_01',
    title: 'Programmer Jokes - Part 01',
  },
  /*
	  'historyPart': (partId) => ({
	    to: `/history-of-america/part-${partId}`,
	    title: `History of America - Part ${partId}`,
	  }),
	  
	  'home': {
	    to: '/',
	    title: 'Home Page',
	  },
  
  
	  import { Link } from 'react-router-dom';
	  import { articleLinks } from '../../../data/articleLinks';
	
	  // With parameterized link
	  const partId = '02';
	  const { to, title } = articleLinks.historyPart(partId);
	
	  <Link to={to} title={title}>
	    {title}
	  </Link>
	
	  // Static link
	  const homeLink = articleLinks.home;
	
	  <Link to={homeLink.to} title={homeLink.title}>
	    {homeLink.title}
	  </Link>
   */
  // add more as needed
};

